import { isSet } from '../utils/isSet';
import { Dropdown } from './Dropdown';

class ContentNav {
    constructor(root) {
        this.root = root;
        this.documentElm = document.documentElement;

        this.dropdownTriggerElm = root.querySelector('#content-menu-trigger');
        this.dropdownMenuElm = root.querySelector('#content-menu');

        this.dropdownTriggerSpanElm = this.dropdownTriggerElm.querySelector('span');

        this.init();
    }

    init(){
        this.init__links();
        this.checkClientWidth();
        this.setContentNavigationHeight();

        this.checkClientWidthBound = this.checkClientWidth.bind(this);
        window.addEventListener(
            'resize', 
            this.checkClientWidthBound
        );

        this.setContentNavigationHeightBound = this.setContentNavigationHeight.bind(this);
        window.addEventListener(
            'resize', 
            this.setContentNavigationHeightBound
        );

    }

    init__links(){
        const content = document.querySelector('.hentry');
        const sections = content.querySelectorAll('section[data-label]');

        if(!isSet(sections) || sections.length === 0) this.root.remove();
        
        sections.forEach((section) => {
            const label = section.dataset.label;
            if(!isSet(label) || label === '') return;

            const id = section.id;
            if(!isSet(id) || id === '') return;

            const li__Elm = document.createElement('li');
            const a__Elm = document.createElement('a');
            a__Elm.textContent = label;
            a__Elm.href = '#' + id;

            li__Elm.append(a__Elm);

            this.dropdownMenuElm.append(li__Elm);
        });
    }

    init__dropdown(){
        if(this.dropdownAPI && this.dropdownTriggerElm.hasAttribute('aria-haspopup')) return;

        this.dropdownTriggerElm.setAttribute('aria-haspopup', 'true');
        this.dropdownTriggerElm.setAttribute('aria-expanded', 'false');
        this.dropdownTriggerElm.removeAttribute('disabled');
        this.dropdownTriggerElm.setAttribute('aria-controls', this.dropdownMenuElm.id);
        this.dropdownMenuElm.setAttribute('aria-labelledby', this.dropdownTriggerElm.id);

        if(this.dropdownAPI) return;

        this.dropdownAPI = new Dropdown(
            this.root,
            {
                onAfterOpen: (obj, e) => {
                    this.dropdownTriggerSpanElm.textContent = 'Close';
                },
                onAfterClose: (obj, e) => {
                    this.dropdownTriggerSpanElm.textContent = 'On This Page';
                },
                closeOnItemClick: true
            }
        )
    }

    destroy__dropdown(){
        if(!this.dropdownAPI && !this.dropdownTriggerElm.hasAttribute('aria-haspopup')) return;

        this.dropdownTriggerElm.removeAttribute('aria-haspopup');
        this.dropdownTriggerElm.removeAttribute('aria-expanded');
        this.dropdownTriggerElm.removeAttribute('aria-controls');
        this.dropdownTriggerElm.setAttribute('disabled', 'true');
        this.dropdownMenuElm.removeAttribute('aria-labelledby');

        if(!this.dropdownAPI) return;

        this.dropdownAPI.destroy();
        this.dropdownAPI = null;
    }

    checkClientWidth(){
        const width = document.body.clientWidth;

        if(width < 1180){
            this.init__dropdown();
        } else{
            this.destroy__dropdown();
        }
    }

    setContentNavigationHeight(){
        let contentNavigationElm = document.querySelector('.header__navigation');
        if(!isSet(contentNavigationElm)) return;

        let contentNavigationHeight = contentNavigationElm.offsetHeight;
        if(contentNavigationHeight === this.contentNavigationHeight) return;

        this.documentElm.style.setProperty('--content-navigation-height', contentNavigationHeight + 'px');
        this.contentNavigationHeight = contentNavigationHeight;
    }
}

export { ContentNav }